// Rebuy's Smart Cart is rendered at runtime by the app, so the bar is injected
// into its DOM instead of living in a Liquid file. Smart Cart re-renders its
// whole subtree on every cart change, which is why the node is re-mounted on
// each rebuy:cart.* event and by a MutationObserver safety net.
const REBUY_CART_ROOT_SELECTORS = ['.rebuy-cart__flyout', '.rebuy-cart'];

function getRebuyCartRoot() {
    for (const selector of REBUY_CART_ROOT_SELECTORS) {
        const root = document.querySelector(selector);
        if (root) return root;
    }

    /* Fallback: .rebuy-cart__checkout-button is the one Smart Cart selector proven
       to exist in this store (the checkout button test relies on it), so climb from
       it to the outermost rebuy-cart ancestor when the root classes don't match. */
    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
    if (!checkoutButton) return null;

    let root = null;
    let current = checkoutButton.parentElement;

    while (current && current !== document.body) {
        const classAttribute = current.getAttribute('class') || '';
        if (classAttribute.indexOf('rebuy-cart') !== -1) root = current;
        current = current.parentElement;
    }

    return root;
}

// cents, USD (store does not ship internationally). Set in Theme settings → Cart,
// exposed by snippets/js-variables.liquid; falls back to $95 if left blank.
const DEFAULT_FREE_SHIPPING_THRESHOLD = 9500;
const configuredThreshold = window.themeVariables?.settings?.cartProgressBarThreshold;
const FREE_SHIPPING_THRESHOLD = configuredThreshold > 0 ? configuredThreshold : DEFAULT_FREE_SHIPPING_THRESHOLD;

// Inline richtext from the same settings group; [amount] is replaced with the
// remaining amount. Defaults cover a blank field.
const REMAINING_MESSAGE = window.themeVariables?.settings?.cartProgressBarRemainingText ||
    'Add <strong>[amount]</strong> more to enjoy <strong>free US shipping</strong>';
const COMPLETE_MESSAGE = window.themeVariables?.settings?.cartProgressBarCompleteText ||
    '<strong>Congrats,</strong> you\'ve received <strong>free US shipping!</strong>';

function setupCartProgressBar() {
    try {
        // Decorative: the message text already carries the meaning. fill is
        // currentColor so the icon follows the message color set in cart-progress-bar.css.
        const SHIPPING_ICON =
            '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
            '<path d="M23.5702 2.43795L16.2187 0.0379495C16.0887 -0.0126498 15.9445 -0.0126498 15.8145 0.0379495L8.46298 2.43795C8.21023 2.51445 8.03398 2.7672 8.03398 3.04545V12.695C8.03398 12.9732 8.21023 13.2004 8.46298 13.3017L15.8145 15.7017C15.8798 15.7226 15.9485 15.7312 16.017 15.7272C16.092 15.7272 16.143 15.7272 16.2195 15.7017L23.5702 13.2762C23.823 13.2012 24 12.9477 24 12.6702V3.0447C24 2.7672 23.823 2.5392 23.5702 2.4387V2.43795ZM15.3855 14.2369L9.29698 12.2419V3.9027L11.7217 4.6857V9.4107C11.7217 9.76395 12 10.0422 12.354 10.0422C12.7072 10.0422 12.9855 9.7647 12.9855 9.40995V5.11545L15.4102 5.89845V14.2354H15.3855V14.2369ZM16.017 4.78845L14.2995 4.23345L15.5115 3.8037C15.84 3.67695 16.017 3.3237 15.8902 2.9952C15.7642 2.6667 15.4102 2.5152 15.0817 2.6157L12.3795 3.60045L10.6867 3.04545L16.0177 1.3017L21.348 3.0447L16.0177 4.7877L16.017 4.78845ZM22.737 12.2412L20.3115 13.0242V10.2957C20.3123 10.2125 20.2965 10.1301 20.265 10.0531C20.2336 9.97611 20.1871 9.90618 20.1283 9.84737C20.0695 9.78857 19.9996 9.74209 19.9226 9.71064C19.8456 9.67918 19.7631 9.6634 19.68 9.6642C19.326 9.6642 19.074 9.9417 19.074 10.2957V13.4539L16.6485 14.2369V5.8992L22.737 3.9042V12.2412ZM5.10298 3.7272H0.631476C0.548387 3.7264 0.465971 3.74216 0.389042 3.77357C0.312112 3.80497 0.242211 3.85139 0.183421 3.91011C0.124631 3.96883 0.0781291 4.03868 0.0466322 4.11557C0.0151354 4.19246 -0.000725569 4.27486 -2.42952e-05 4.35795C-2.42952e-05 4.7112 0.277476 4.98945 0.631476 4.98945H5.10298C5.45698 4.98945 5.73448 4.71195 5.73448 4.35795C5.70973 4.00395 5.43148 3.7272 5.10298 3.7272ZM5.10298 7.23795H0.631476C0.548259 7.23715 0.465719 7.25296 0.38869 7.28446C0.311661 7.31595 0.241692 7.36251 0.182881 7.42139C0.124071 7.48027 0.0776006 7.55029 0.0461936 7.62736C0.0147865 7.70442 -0.000926232 7.78698 -2.42952e-05 7.8702C-2.42952e-05 8.22345 0.277476 8.5017 0.631476 8.5017H5.10298C5.45698 8.5017 5.73448 8.2242 5.73448 7.8702C5.73177 7.70356 5.66437 7.5445 5.54652 7.42665C5.42867 7.3088 5.26962 7.2414 5.10298 7.2387V7.23795ZM5.10298 10.7502H0.631476C0.548323 10.7494 0.465845 10.7652 0.388866 10.7966C0.311887 10.8281 0.241952 10.8746 0.183151 10.9334C0.124351 10.9922 0.0778651 11.0621 0.0464131 11.1391C0.0149611 11.2161 -0.000825823 11.2985 -2.42952e-05 11.3817C-2.42952e-05 11.7349 0.277476 12.0132 0.631476 12.0132H5.10298C5.45698 12.0132 5.73448 11.7357 5.73448 11.3817C5.73177 11.2151 5.66437 11.056 5.54652 10.9382C5.42867 10.8203 5.26962 10.7529 5.10298 10.7502Z" fill="currentColor"/>' +
            '</svg>';

        // "Shipping — FREE" row above the cart subtotal. Rebuy emits no shipping
        // line in the flyout, so the row is injected here, same technique as
        // setupSidecartCopy()'s applyShippingRow in rebuy-cart-optimization.js —
        // only exists once the threshold is met, dropped otherwise instead of
        // showing invented copy.
        const SHIPPING_ROW_CLASS = 'rj-shipping-row';
        const SHIPPING_LABEL = 'Shipping';
        // Uppercased in CSS so the copy stays readable here
        const SHIPPING_FREE_LABEL = 'Free';

        const applyShippingRow = (isEarned) => {
            const subtotal = document.querySelector('.rebuy-cart__flyout-subtotal');
            let row = document.querySelector(`.${SHIPPING_ROW_CLASS}`);

            // Anchored on the subtotal *wrapper*, not the subtotal row: that row's
            // parent is a flex row, so a sibling inserted inside it lands beside the
            // "Subtotal (n items)" label instead of above it.
            const anchor = subtotal?.closest('[data-rebuy-component="cart-subtotal"]') || subtotal;

            if (!isEarned || !anchor?.parentNode) {
                row?.remove();
                return;
            }

            if (!row) {
                row = document.createElement('div');
                row.className = SHIPPING_ROW_CLASS;

                const label = document.createElement('span');
                label.className = `${SHIPPING_ROW_CLASS}__label`;
                label.textContent = SHIPPING_LABEL;

                const badge = document.createElement('span');
                badge.className = `${SHIPPING_ROW_CLASS}__badge`;
                badge.textContent = SHIPPING_FREE_LABEL;

                row.append(label, badge);
            }

            // Re-anchored on every pass, not only when built: Rebuy re-renders the
            // subtotal block, which leaves an existing row stranded after it.
            if (anchor.previousElementSibling !== row) {
                anchor.parentNode.insertBefore(row, anchor);
            }
        };

        let lastTotal = null;
        let rescheduled = false;
        let fallbackWaitStartedAt = null;
        let fallbackRetryTimer = null;

        const formatMoney = (cents) => {
            const [whole, fraction] = (Math.max(0, cents) / 100).toFixed(2).split('.');
            return '$' + whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + fraction;
        };

        const buildNode = () => {
            const node = document.createElement('div');
            node.className = 'rj-cart-progress';
            node.setAttribute('data-rj-progress', '');
            node.innerHTML =
                '<p class="rj-cart-progress__message">' + SHIPPING_ICON +
                '<span class="rj-cart-progress__text" aria-live="polite"></span></p>' +
                '<div class="rj-cart-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100">' +
                '<span class="rj-cart-progress__fill"></span></div>';
            return node;
        };

        /* Anchors are matched with class*= instead of exact class names: Rebuy's
           Smart Cart markup varies by version and template, and exact selectors
           silently found nothing. Queried against the document rather than the cart
           root so a mismatched root can't hide the whole subtree.

           Primary anchors are content landmarks, so they put the bar exactly where
           the design shows it — right under the cart header. */
        const MOUNT_ANCHORS_PRIMARY = [
            ['[class*="rebuy-cart__progress"]', 'before'],
            ['[class*="rebuy-cart__header"]', 'after'],
            ['[class*="rebuy-cart__flyout-header"]', 'after'],
            ['[class*="rebuy-cart__flyout-items"]', 'before'],
            ['[class*="rebuy-cart__items"]', 'before'],
            ['[class*="rebuy-cart__flyout-item"]', 'before']
        ];

        /* Structural last resort: these prepend into a wrapper, which lands the bar
           above the cart title. Only used once the cart has clearly settled without
           any primary anchor — see FALLBACK_MOUNT_DELAY. */
        const MOUNT_ANCHORS_FALLBACK = [
            ['[class*="rebuy-cart__flyout-content"]', 'prepend'],
            ['[class*="rebuy-cart__content"]', 'prepend'],
            ['[class*="rebuy-cart__flyout"]', 'prepend'],
            ['[class*="rebuy-cart"]', 'prepend']
        ];

        /* Add to cart re-renders the Smart Cart subtree: for a few frames the outer
           wrapper exists but the header does not, and mounting in that window pins
           the bar above the cart title. Hold the fallback anchors for this long so
           the header can show up first. */
        const FALLBACK_MOUNT_DELAY = 1200;

        // Logged once per page load: the warning fires on every render attempt and
        // the tree dump is only useful the first time.
        let mountWarningLogged = false;

        const dumpTree = (element, depth) => {
            if (!element || depth > 3) return '';
            return Array.from(element.children).map((child) => {
                const classAttribute = child.getAttribute('class');
                const label = child.tagName.toLowerCase() +
                    (classAttribute ? '.' + classAttribute.trim().split(/\s+/).join('.') : '');
                return '  '.repeat(depth) + label + '\n' + dumpTree(child, depth + 1);
            }).join('');
        };

        const findAnchor = (anchors) => {
            for (const [selector, position] of anchors) {
                const anchor = document.querySelector(selector);
                if (!anchor) continue;
                if (position !== 'prepend' && !anchor.parentNode) continue;
                return { anchor, position, selector };
            }
            return null;
        };

        /* Idempotent on purpose: it runs on every render, so a bar that a re-render
           left in the wrong place is moved instead of duplicated. */
        const placeNode = (node, target, tier) => {
            const { anchor, position, selector } = target;
            const parent = position === 'prepend' ? anchor : anchor.parentNode;
            let reference;

            if (position === 'prepend') reference = anchor.firstChild;
            else if (position === 'after') reference = anchor.nextSibling;
            else reference = anchor;

            // already sitting at the target spot — the node itself is the reference
            if (reference === node) reference = node.nextSibling;

            if (node.parentNode !== parent || node.nextSibling !== reference) {
                parent.insertBefore(node, reference);
            }

            node.dataset.rjMountedVia = selector + ':' + position;
            node.dataset.rjMountedTier = tier;
        };

        const clearFallbackWait = () => {
            fallbackWaitStartedAt = null;
            if (fallbackRetryTimer !== null) {
                clearTimeout(fallbackRetryTimer);
                fallbackRetryTimer = null;
            }
        };

        const mount = () => {
            let node = document.querySelector('[data-rj-progress]');
            const primary = findAnchor(MOUNT_ANCHORS_PRIMARY);

            if (primary) {
                clearFallbackWait();
                if (!node) node = buildNode();
                placeNode(node, primary, 'primary');
                return node;
            }

            if (fallbackWaitStartedAt === null) fallbackWaitStartedAt = Date.now();

            const waited = Date.now() - fallbackWaitStartedAt;

            if (waited < FALLBACK_MOUNT_DELAY) {
                // The observer only fires on DOM changes, so the retry has to be armed
                // here: the cart can settle without another mutation.
                if (fallbackRetryTimer === null) {
                    fallbackRetryTimer = setTimeout(() => {
                        fallbackRetryTimer = null;
                        render(lastTotal);
                    }, FALLBACK_MOUNT_DELAY - waited);
                }
                return node;
            }

            const fallback = findAnchor(MOUNT_ANCHORS_FALLBACK);

            if (fallback) {
                if (!node) node = buildNode();
                placeNode(node, fallback, 'fallback');
                return node;
            }

            if (!mountWarningLogged) {
                mountWarningLogged = true;
                const cartRoot = getRebuyCartRoot();
                console.warn(
                    'Cart progress bar: no mount point found in the Smart Cart DOM.\n' +
                    'Cart root: ' + (cartRoot ? (cartRoot.getAttribute('class') || cartRoot.tagName) : 'NONE') + '\n' +
                    'Tree:\n' + (cartRoot ? dumpTree(cartRoot, 0) : '(no root)')
                );
            }

            return node;
        };

        const render = (totalCents) => {
            const node = mount();
            if (!node) return;

            if (typeof totalCents !== 'number' || totalCents <= 0) {
                node.hidden = true;
                applyShippingRow(false);
                return;
            }

            node.hidden = false;

            const isComplete = totalCents >= FREE_SHIPPING_THRESHOLD;
            const percent = Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD) * 100);
            const message = isComplete
                ? COMPLETE_MESSAGE
                : REMAINING_MESSAGE.split('[amount]').join(formatMoney(FREE_SHIPPING_THRESHOLD - totalCents));

            applyShippingRow(isComplete);
            node.classList.toggle('rj-cart-progress--complete', isComplete);

            const text = node.querySelector('.rj-cart-progress__text');
            if (text && text.innerHTML !== message) text.innerHTML = message;

            const track = node.querySelector('.rj-cart-progress__track');
            if (track) track.setAttribute('aria-valuenow', String(Math.round(percent)));

            // Custom property instead of style.width: the stylesheet needs
            // !important to survive Rebuy's CSS, and that beats an inline width.
            node.style.setProperty('--rj-progress-width', percent.toFixed(2) + '%');
        };

        // Rebuy hands the fresh cart in the event detail; the fallbacks cover the
        // MutationObserver path, where there is no event to read from.
        const resolveTotal = (event) => {
            const cart = event?.detail?.cart || window.Rebuy?.SmartCart?.cart || window.Rebuy?.Cart?.cart;

            if (cart && typeof cart.total_price === 'number') {
                return Promise.resolve(cart.total_price);
            }

            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then((response) => response.json())
                .then((data) => data.total_price)
                .catch(() => lastTotal);
        };

        const update = (event) => {
            resolveTotal(event).then((totalCents) => {
                if (typeof totalCents === 'number') lastTotal = totalCents;
                render(lastTotal);
            });
        };

        ['rebuy:cart.ready', 'rebuy:cart.add', 'rebuy:cart.change', 'rebuy:cart.remove', 'rebuy:cart.show']
            .forEach((eventName) => document.addEventListener(eventName, update));

        // Safety net: Smart Cart rebuilds its subtree without always firing an event,
        // which drops the injected node. Re-render from the cached total instead of
        // refetching, and bail out early so the observer stays cheap.
        const domWatcher = new MutationObserver(() => {
            if (rescheduled) return;

            // A node parked on a fallback anchor still needs re-checking: the header
            // it was waiting for may have rendered since.
            const node = document.querySelector('[data-rj-progress]');
            if (node && node.dataset.rjMountedTier === 'primary') return;

            rescheduled = true;
            requestAnimationFrame(() => {
                rescheduled = false;
                if (lastTotal === null) update();
                else render(lastTotal);
            });
        });

        domWatcher.observe(document.body, {
            childList: true,
            subtree: true
        });

        update();
    } catch (error) {
        console.error('Error setting up cart progress bar:', error);
    }
}

// The cart root only exists once Rebuy's Smart Cart mounts, so this waits for it
// instead of running setupCartProgressBar() eagerly.
function initCartProgressBar() {
    const cartProgressObserver = new MutationObserver(() => {
        try {
            const cartRoot = getRebuyCartRoot();

            if (cartRoot && !cartRoot.dataset.rjProgressInitialized) {
                cartRoot.dataset.rjProgressInitialized = "true";
                setupCartProgressBar();
                cartProgressObserver.disconnect();
            }
        } catch (error) {
            console.error('Error initializing cart progress bar:', error);
        }
    });

    cartProgressObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}

if (document.body) {
    initCartProgressBar();
} else {
    document.addEventListener('DOMContentLoaded', initCartProgressBar, { once: true });
}
